// @flow
import { PrivacyPolicyActionTypes } from './constants';

const INIT_STATE = {
    privacyPolicy: {},
    loading: false,
    error: false,
    formSubmited: false,
};

type PrivacyPolicyAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { privacyPolicy?: {} | null, listaPrivacyPolicy?: [] | null, loading?: boolean, +value ?: boolean };

const PrivacyPolicy = (state: State = INIT_STATE, action: PrivacyPolicyAction): any => {
    // console.log(action);
    switch (action.type) {
        case PrivacyPolicyActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case PrivacyPolicyActionTypes.UPDATE_PRIVACY_POLICY: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }


        case PrivacyPolicyActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case PrivacyPolicyActionTypes.UPDATE_PRIVACY_POLICY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case PrivacyPolicyActionTypes.UPDATE_PRIVACY_POLICY:
            return { ...state, error: false, loading: true };
        case PrivacyPolicyActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                privacyPolicy: {},
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default PrivacyPolicy;
